<template>
    <div class="cmp cmp-method-list list mb-4" v-bind:class="{ 'error': showError }">
        <ul class="method-list component-loading" :class="{ 'is-loading': isBasketLoading || isCheckoutReadonly }">
            <template v-for="paymentProvider in methodOfPaymentList">
                <li v-if="paymentProvider.key !== klarnaPaymentKey"
                    class="method-list-item"
                    :data-id="paymentProvider.id">
                    <input type="radio"
                           :id="'paymentMethod' + _uid + paymentProvider.id"
                           :name="'MethodOfPaymentID' + _uid"
                           :value="paymentProvider.id"
                           @change="onPaymentProviderChange(paymentProvider)"
                           :checked="methodOfPaymentId === paymentProvider.id"
                           :disabled="!paymentProvider.isSelectable || isCheckoutReadonly">
                    <label class="provider-select-label" :for="'paymentMethod' + _uid + paymentProvider.id"
                           :class="paddingClasses"
                           :style="paddingInlineStyles"
                           v-tooltip="isPaymentMethodExcluded(paymentProvider.id)"
                           data-toggle="tooltip"
                           data-placement="top"
                           :data-title="$translate('Ceres::Template.checkoutChangeShippingProfileHint')">
                        <span class="icon">
                            <img class="img-fluid" :src="paymentProvider.icon" :alt="paymentProvider.name" :title="paymentProvider.name">
                        </span>
                        <span class="d-inline-block w-100 text-center pl-1 pr-1">
                            {{ paymentProvider.name }}
                        </span>
                    </label>
                    <popper trigger="hover" placement="bottom"
                            :body-class="paymentProvider.sourceUrl || getDescription(paymentProvider) ? '' : 'd-none'"
                            :close-mouse-out="!paymentProvider.sourceUrl">
                        <template #handle>
                            <span class="checkout__popover">i</span>
                        </template>
                        <template #title>
                            {{ paymentProvider.name }}
                        </template>
                        <template #content>
                            <div v-if="paymentProvider.sourceUrl" class="float-right">
                                <a :href="paymentProvider.sourceUrl" rel="noopener noreferrer" target="_blank">
                                    <i class="fa fa-external-link" aria-hidden="true"></i>
                                    {{ $translate("Ceres::Template.checkoutPaymentMethodDetailsLink") }}
                                </a>
                            </div>
                            {{ getDescription(paymentProvider) }}
                        </template>
                    </popper>
                </li>
            </template>
            <li v-if="klarnaPayment" class="method-list-item" :data-id="klarnaPayment.id">
                <input type="radio"
                       :id="'paymentMethod' + _uid + klarnaPayment.id"
                       :name="'MethodOfPaymentID' + _uid"
                       :value="klarnaPayment.id"
                       @change="onPaymentProviderChange(klarnaPayment)"
                       :checked="methodOfPaymentId === klarnaPayment.id"
                       :disabled="!klarnaPayment.isSelectable || isCheckoutReadonly">
                <label class="provider-select-label" :for="'paymentMethod' + _uid + klarnaPayment.id"
                       :class="paddingClasses"
                       :style="paddingInlineStyles"
                       v-tooltip="isPaymentMethodExcluded(klarnaPayment.id)"
                       data-toggle="tooltip"
                       data-placement="top"
                       :data-title="$translate('Ceres::Template.checkoutChangeShippingProfileHint')">
                    <span class="icon">
                        <img class="img-fluid" :src="klarnaPayment.icon" :alt="klarnaPayment.name" :title="klarnaPayment.name">
                    </span>
                    <span class="d-inline-block w-100 text-center">
                        {{ klarnaPayment.customName }}
                    </span>
                </label>
                <popper trigger="hover" placement="bottom"
                        :body-class="klarnaPayment.sourceUrl || klarnaPayment.customDescription ? '' : 'd-none'"
                        :close-mouse-out="!klarnaPayment.sourceUrl">
                    <template #handle>
                        <span class="checkout__popover">i</span>
                    </template>
                    <template #title>
                        {{ klarnaPayment.customName }}
                    </template>
                    <template #content>
                        <div v-if="klarnaPayment.sourceUrl" class="float-right">
                            <a :href="klarnaPayment.sourceUrl" rel="noopener noreferrer" target="_blank">
                                <i class="fa fa-external-link" aria-hidden="true"></i>
                                {{ $translate("Ceres::Template.checkoutPaymentMethodDetailsLink") }}
                            </a>
                        </div>
                        {{ klarnaPayment.customDescription }}
                    </template>
                </popper>
            </li>
        </ul>
    </div>
</template>

<script>
import TranslationService from "ceres/app/services/TranslationService";
import { mapState } from "vuex";
import { isDefined } from "ceres/app/helper/utils";
import { isNullOrUndefined } from "ceres/app/helper/utils";
const NotificationService = require("ceres/app/services/NotificationService");

export default
{
    props:
    {
        template:
        {
            type: String,
            default: "#vue-payment-provider-select"
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    data()
    {
        return {
            klarnaPaymentKey: 'Klarna',
            payPalPaymentKey: 'plentyPayPal'
        }
    },

    computed:
    {
        klarnaPayment()
        {
            let klarnaPayment = this.methodOfPaymentList.find(method => method.key === this.klarnaPaymentKey);

            if(!isNullOrUndefined(klarnaPayment))
            {
                klarnaPayment.customName        = TranslationService.translate("OD3dprimaV2::Template.checkoutKlarnaName");
                klarnaPayment.customDescription = TranslationService.translate("OD3dprimaV2::Template.checkoutKlarnaDescription");

                return klarnaPayment;
            }

            return false;
        },

        ...mapState({
            methodOfPaymentList: state => state.checkout.payment.methodOfPaymentList,
            methodOfPaymentId: state => state.checkout.payment.methodOfPaymentId,
            showError: state => state.checkout.validation.paymentProvider.showError,
            isBasketLoading: state => state.basket.isBasketLoading,
            isCheckoutReadonly: state => state.checkout.readOnly,
            selectedShippingProfile: state => state.checkout.shipping.selectedShippingProfile
        })
    },

    /**
     * Initialise the event listener
     */
    created()
    {
        this.$store.commit("setPaymentProviderValidator", this.validate);
    },

    methods: {
        /**
         * Event when changing the payment provider
         */
        onPaymentProviderChange(newMethodOfPayment)
        {
            this.$store.dispatch("selectMethodOfPayment", newMethodOfPayment.id)
                .then(data =>
                {
                    document.dispatchEvent(new CustomEvent("afterPaymentMethodChanged", { detail: this.methodOfPaymentId }));
                },
                error =>
                {
                    console.log("error");
                });

            this.validate();
        },

        validate()
        {
            const showError = !(this.methodOfPaymentId > 0);

            this.$store.commit("setPaymentProviderShowError", showError);

            if (showError)
            {
                NotificationService.error(
                    TranslationService.translate("Ceres::Template.checkoutCheckPaymentProvider")
                );
            }
        },

        isPaymentMethodExcluded(paymentMethodId)
        {
            if (isDefined(this.selectedShippingProfile) && isDefined(this.selectedShippingProfile.excludedPaymentMethodIds))
            {
                return this.selectedShippingProfile.excludedPaymentMethodIds.includes(paymentMethodId);
            }
            else
            {
                return false;
            }
        },

        getDescription(provider)
        {
            if(provider.key === this.payPalPaymentKey)
            {
                const translation = TranslationService.translate("OD3dprimaV2::Template.checkoutPayPalDescription");
                return translation !== "OD3dprimaV2::Template.checkoutPayPalDescription" ? translation : provider.description
            }

            return provider.description
        }
    }
};
</script>
